import { type TFunction } from 'i18next'
import * as Yup from 'yup'
import dayjs from 'dayjs'

/*
 * Refactored here from FinanceReportPage / MarketingReportPage / BusinessMetricsPage
 */
export const createStartDateEndDateValidationSchema = (t: TFunction) =>
  Yup.object({
    interval: Yup.object({
      from: Yup.date()
        .typeError(t('admin.reportsPage.startDateIsRequired'))
        .required(t('admin.reportsPage.startDateIsRequired'))
        .max(dayjs().add(1, 'day').toDate(), t('admin.reportsPage.futureDate')),
      till: Yup.date()
        .typeError(t('admin.reportsPage.endDateIsRequired'))
        .required(t('admin.reportsPage.endDateIsRequired'))
        .min(Yup.ref('from'), t('admin.reportsPage.afterDate'))
        .max(dayjs().add(1, 'day').toDate(), t('admin.reportsPage.futureDate')),
    }),
  }).defined()

export const createDateOnlyValidationSchema = (t: TFunction) =>
  Yup.object({
    date: Yup.date()
      .typeError(t('admin.reportsPage.dateIsRequired'))
      .required(t('admin.reportsPage.dateIsRequired'))
      .max(dayjs().add(1, 'day').toDate(), t('admin.reportsPage.futureDate')),
  }).defined()
